/**
 * Traduit un ingrédient FR (ou autre) vers EN pour l'API TheMealDB
 */

import { ingredientTranslationsFRtoEN } from "../data/index.js";

const normalize = (str) =>
  str
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export function translateToEnglish(ingredient) {
  const normalized = normalize(ingredient);
  return ingredientTranslationsFRtoEN[normalized] || ingredient;
}
